export const iconFontAwesomeReligionDove = (
	<i className="fa-solid fa-dove"></i>
);
